export default store => store.errors;
